import React from 'react';
import { ArrowUp } from 'lucide-react';
import useScrollFlag from '../hooks/useScrollFlag';

const BackToTop = () => {
  const visible = useScrollFlag(700);
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Revenir en haut de la page"
      data-testid="back-to-top"
      className={`fixed right-5 bottom-24 lg:bottom-8 z-40 w-11 h-11 flex items-center justify-center bg-[#010c23] text-white border border-white/10 shadow-lg hover:bg-[#ff7300] transition-all duration-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
    >
      <ArrowUp size={18} />
    </button>
  );
};

export default BackToTop;
